// A seed list of extremely common / breached passwords (publicly known from repeated breach
// analyses — e.g. NCSC/HIBP "most common passwords" reporting), checked case-insensitively.
// This is a starting point, not full HIBP coverage: swap in a proper frequency-ordered corpus
// (e.g. SecLists' rockyou-frequency list) before production launch — tracked in OPERATOR_INPUTS.md.
const COMMON_BREACHED_PASSWORDS = [
  '123456',
  '123456789',
  '12345678',
  '12345',
  '1234567',
  '1234567890',
  'qwerty',
  'qwerty123',
  'password',
  'password1',
  'password123',
  '111111',
  '1234',
  '123123',
  'abc123',
  'iloveyou',
  'admin',
  'admin123',
  'welcome',
  'welcome1',
  'monkey',
  'dragon',
  'letmein',
  'trustno1',
  'sunshine',
  'master',
  'hello',
  'hello123',
  'freedom',
  'whatever',
  'qazwsx',
  'football',
  'baseball',
  'superman',
  '1qaz2wsx',
  'starwars',
  'zaq12wsx',
  'passw0rd',
  'p@ssw0rd',
  'p@ssword',
  '000000',
  '654321',
  '666666',
  '7777777',
  '123321',
  'aa123456',
  'qwertyuiop',
  'access',
  'flower',
  'hottie',
  'loveme',
  'jordan23',
  'shadow',
  'michael',
  'jennifer',
  'iloveyou1',
  'princess',
  'qwerty1',
  'letmein1',
  'changeme',
  'changeme1',
  'astrologer',
  'astrology',
  'astrologermatch',
];

const BREACHED_PASSWORD_SET = new Set(COMMON_BREACHED_PASSWORDS.map((p) => p.toLowerCase()));

export function isKnownBreachedPassword(password: string): boolean {
  return BREACHED_PASSWORD_SET.has(password.toLowerCase());
}
